import { createSlice } from '@reduxjs/toolkit';

const defaultState = {
  getAllStagedPremiumsForCombination: false,
  allStagedPremiumSetting: [],
  applicationPremiumSetting: [],
  stagedPremiumSetting: {},
  stagesSubSettings: [],
  agentCommissionsList: [],
  underwriterRatePercentage: '',
  coveragesOptions: [],
  deductiblesOptions: [],
  endorsementsOptions: [],
  selectedCoverageType: '',
  selectedDeductible: '',
  selectedEndorsement: '',
  coverageOptionName: '',
  deductibleOptionName: '',
  endorsementOptionName: '',
  fetchingCurrent: false,
  fetchingSingle: false,
  fetchingAllForCombination: false,
};

const actions = {
  resetStagedPremiumState: () => {
    return defaultState;
  },
  resetDisplayedStagedPremiumSetting: (state) => {
    state.allStagedPremiumSetting = [];
    state.getAllStagedPremiumsForCombination = false;
    state.stagedPremiumSetting = {};
  },
  changeStagedPremiumData: (state, { payload }) => {
    const { key, value } = payload;
    state[key] = value;
  },
  getCurrentStagedPremium: (state) => {
    state.fetchingCurrent = true;
  },
  failedGetCurrentStagedPremium: (state) => {
    state.fetchingCurrent = false;
  },
  receiveCurrentStagedPremium: (state, action) => {
    state.fetchingCurrent = false;
    const stagedPremiumSettings = action.payload;
    const agentsCommissions =
      action.payload?.stagedPremiumSubSettings[0]?.stagedPremiumSubSettingCommissionDtos.map(
        (c) => {
          return { ...c, id: c.lawsysId, name: c.lawsysName };
        }
      );
    const underwriterRate =
      action.payload?.stagedPremiumSubSettings[0]?.underwriterRatePercentage;
    (state.stagedPremiumSetting = stagedPremiumSettings),
      (state.agentCommissionsList = agentsCommissions),
      (state.underwriterRatePercentage = underwriterRate);
  },
  getAllStagedPremium: (state) => {
    state.fetchingAllForCombination = true;
  },
  failedGetAllStagedPremium: (state) => {
    state.fetchingAllForCombination = false;
  },
  receiveAllStagedPremium: (state, action) => {
    state.fetchingAllForCombination = false;
    state.allStagedPremiumSetting = action.payload;
  },
  receiveApplicationPremiums: (state, action) => {
    if (
      action.payload?.applicationPremiumSubSettingsDtos?.length === 0 &&
      action.payload?.applicationStagedPremiumSubSettingDtos?.length === 0
    ) {
      state.fetching = false;
      state.errorResponse = 'Failed to load application premium settings';
    } else if (
      action.payload?.applicationStagedPremiumSubSettingDtos &&
      action.payload?.applicationStagedPremiumSubSettingDtos?.length !== 0
    ) {
      const underwriterRatePercent =
        action.payload?.applicationStagedPremiumSubSettingDtos[0]
          ?.underwriterRatePercentage;
      const subSettings =
        action.payload?.applicationStagedPremiumSubSettingDtos?.reduce(
          (values, stage) => {
            values[stage.stageMachineName] = {
              id: stage.id.toString(),
              stageName: stage.stageName,
              stageMachineName: stage.stageMachineName,
              limitOfIndemnity: stage.limitOfIndemnity.toString(),
              premiumAmount: stage.premiumAmount.toString(),
              underwriterRate: stage.underwriterRate.toString(),
              underwriterRatePercentage:
                stage.underwriterRatePercentage.toString(),
              stagedPremiumSubSettingCommissionDtos:
                stage.stagedPremiumSubSettingCommissionDtos,
            };
            return values;
          },
          {}
        );
      const agentsList =
        action.payload?.applicationStagedPremiumSubSettingDtos[0]?.stagedPremiumSubSettingCommissionDtos?.reduce(
          (values, agent) => {
            values[agent.lawsysId] = {
              id: agent.lawsysId?.toString(),
              lawsysId: agent.lawsysId,
              name: agent.lawsysName,
              commissionPercentage: agent.commissionPercentage,
              commission: agent.commission,
            };
            return values;
          },
          {}
        );

      state.fetching = false;
      state.stagedPremiumSetting = { ...action.payload };
      state.stagesSubSettings = subSettings;
      state.underwriterRatePercentage = underwriterRatePercent;
      state.agentCommissionsList = agentsList;
    }
  },
  receivePatchedApplicationPremium: (state, action) => {
    if (action.payload.applicationStagedPremiumSubSettingDtos) {
      if (action.payload.applicationStagedPremiumSubSettingDtos.length > 0) {
        const underwriterRatePercent =
          action.payload?.applicationStagedPremiumSubSettingDtos[0]
            ?.underwriterRatePercentage;
        const agentCommissions =
          action.payload?.applicationStagedPremiumSubSettingDtos[0].stagedPremiumSubSettingCommissionDtos.map(
            (c) => ({ ...c, id: c.lawsysId, name: c.lawsysName })
          );

        state.fetching = false;
        state.stagedPremiumSetting = action.payload;
        state.stagesSubSettings =
          action.payload?.applicationStagedPremiumSubSettingDtos;
        state.underwriterRatePercentage = underwriterRatePercent;
        state.agentCommissionsList = agentCommissions;
      }
    }
  },
};

const stagedPremiums = createSlice({
  name: 'stagedPremiums',
  initialState: defaultState,
  reducers: actions,
});
export const {
  resetStagedPremiumState,
  resetDisplayedStagedPremiumSetting,
  changeStagedPremiumData,
  getCurrentStagedPremium,
  failedGetCurrentStagedPremium,
  receiveCurrentStagedPremium,
  getAllStagedPremium,
  failedGetAllStagedPremium,
  receiveAllStagedPremium,
  receiveApplicationPremiums,
  receivePatchedApplicationPremium,
} = stagedPremiums.actions;

export default stagedPremiums.reducer;
